export default "__VITE_ASSET__aa06137d__"